import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'
import { ApartmentContextProvider } from './context/ApartmentContext'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <ApartmentContextProvider>
      <App />
    </ApartmentContextProvider>
  </React.StrictMode>
)
